/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  FCMResponseDto,
  RegisterDevice200Response,
  RegisterDeviceDto,
  RemoveDevice200Response,
  RemoveDeviceRequest,
  SendNotificationToUserDto,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    FCMResponseDtoFromJSON,
    FCMResponseDtoToJSON,
    RegisterDevice200ResponseFromJSON,
    RegisterDevice200ResponseToJSON,
    RegisterDeviceDtoFromJSON,
    RegisterDeviceDtoToJSON,
    RemoveDevice200ResponseFromJSON,
    RemoveDevice200ResponseToJSON,
    RemoveDeviceRequestFromJSON,
    RemoveDeviceRequestToJSON,
    SendNotificationToUserDtoFromJSON,
    SendNotificationToUserDtoToJSON,
} from '../models/index';

export interface RegisterDeviceRequest {
    registerDeviceDto: RegisterDeviceDto;
}

export interface RemoveDeviceOperationRequest {
    removeDeviceRequest: RemoveDeviceRequest;
}

export interface SendNotificationToUserRequest {
    sendNotificationToUserDto: SendNotificationToUserDto;
}

/**
 * 
 */
export class FCMApi extends runtime.BaseAPI {

    /**
     * Register or update a device FCM token for the authenticated user
     * Register device for push notifications
     */
    async registerDeviceRaw(requestParameters: RegisterDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RegisterDevice200Response>> {
        if (requestParameters['registerDeviceDto'] == null) {
            throw new runtime.RequiredError(
                'registerDeviceDto',
                'Required parameter "registerDeviceDto" was null or undefined when calling registerDevice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/fcm/register-device`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RegisterDeviceDtoToJSON(requestParameters['registerDeviceDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RegisterDevice200ResponseFromJSON(jsonValue));
    }

    /**
     * Register or update a device FCM token for the authenticated user
     * Register device for push notifications
     */
    async registerDevice(requestParameters: RegisterDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RegisterDevice200Response> {
        const response = await this.registerDeviceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Remove or deactivate device FCM token for the authenticated user
     * Remove device FCM token
     */
    async removeDeviceRaw(requestParameters: RemoveDeviceOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RemoveDevice200Response>> {
        if (requestParameters['removeDeviceRequest'] == null) {
            throw new runtime.RequiredError(
                'removeDeviceRequest',
                'Required parameter "removeDeviceRequest" was null or undefined when calling removeDevice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/fcm/remove-device`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: RemoveDeviceRequestToJSON(requestParameters['removeDeviceRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RemoveDevice200ResponseFromJSON(jsonValue));
    }

    /**
     * Remove or deactivate device FCM token for the authenticated user
     * Remove device FCM token
     */
    async removeDevice(requestParameters: RemoveDeviceOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RemoveDevice200Response> {
        const response = await this.removeDeviceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Send notification to the user
     * Send notification to user
     */
    async sendNotificationToUserRaw(requestParameters: SendNotificationToUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FCMResponseDto>> {
        if (requestParameters['sendNotificationToUserDto'] == null) {
            throw new runtime.RequiredError(
                'sendNotificationToUserDto',
                'Required parameter "sendNotificationToUserDto" was null or undefined when calling sendNotificationToUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // api-key authentication
        }

        const response = await this.request({
            path: `/fcm/send-notification-to-user`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SendNotificationToUserDtoToJSON(requestParameters['sendNotificationToUserDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FCMResponseDtoFromJSON(jsonValue));
    }

    /**
     * Send notification to the user
     * Send notification to user
     */
    async sendNotificationToUser(requestParameters: SendNotificationToUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FCMResponseDto> {
        const response = await this.sendNotificationToUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
